module.exports = __webpack_public_path__ + "static/media/img5.dfab599e.jpg";